var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    id: "Path_20384",
    "data-name": "Path 20384",
    className: "cls-1",
    d: "M0,14v2h6v-2H0ZM0,2v2h10v-2H0ZM10,18v-2h8v-2h-8v-2h-2v6h2ZM4,6v2H0v2h4v2h2v-6h-2ZM18,10v-2h-10v2h10ZM12,6h2v-2h4v-2h-4V0h-2v6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter2);
export default __webpack_public_path__ + "static/media/Filter_2.63b71636fe37906c1395e74ed50899d4.svg";
export { ForwardRef as ReactComponent };